// Components/ui
import { SubsectionBodyContainer } from '../../../../layout';
import { RCS } from './components';
// Types
import { NewAddress } from '../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  RCSs: Array<NewAddress | IContactAddress>;
};

const Body = ({ RCSs }: Props) => {
  return (
    <SubsectionBodyContainer variant="large">
      {RCSs?.map((data) => (
        <RCS key={data.id} data={data} />
      ))}
    </SubsectionBodyContainer>
  );
};

export default Body;
